module.exports = __webpack_public_path__ + "bc28cf36fcfa96ee670786f83cbf3e95.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/school-and-owls.png
// module id = 310
// module chunks = 0